module.exports = __webpack_public_path__ + "img/US-economics.5e8be983.png";